import { DefaultActuatorPosition, DeviceConfig, ActuatorSettings, HardwareDeviceConfig } from "../../../documents/HardwareConfig";
import logger from "../../../../utils/Logger";

export default function migrateHardwareConfigActuator(device: DeviceConfig) {
    if (!device.HardwareDevice) {
        device.HardwareDevice = {} as HardwareDeviceConfig;
    }

    switch (device.HardwareDevice.DefaultActuatorPosition) {
    case DefaultActuatorPosition.RED:
        device.HardwareDevice.DefaultActuatorPosition = DefaultActuatorPosition.LEFT; break;
    case DefaultActuatorPosition.WHITE:
        device.HardwareDevice.DefaultActuatorPosition = DefaultActuatorPosition.RIGHT; break;
    }

    if (!device.HardwareDevice.ActuatorSettings) {
        logger.debug('[config.migration.actuator] Creating HardwareDevice.ActuatorSettings.')
        device.HardwareDevice.ActuatorSettings = {} as ActuatorSettings;
    }

    if (typeof device.HardwareDevice.DefaultActuatorPosition !== 'undefined') {
        if (typeof device.HardwareDevice.ActuatorSettings.DefaultPosition === 'undefined') {
            logger.debug('[config.migration.actuator] Migrating: HardwareDevice.ActuatorSettings.DefaultPosition <- HardwareDevice.DefaultActuatorPosition');
            device.HardwareDevice.ActuatorSettings.DefaultPosition = device.HardwareDevice.DefaultActuatorPosition;
        }
        delete device.HardwareDevice.DefaultActuatorPosition;
    }
    if (!device.HardwareDevice.ActuatorSettings.DefaultPosition) {
        device.HardwareDevice.ActuatorSettings.DefaultPosition = DefaultActuatorPosition.NONE;
    }

    if (typeof device.HardwareDevice.InterlockedActuator !== 'undefined') {
        if (typeof device.HardwareDevice.ActuatorSettings.InterlockedActuator === 'undefined') {
            logger.debug('[config.migration.actuator] Migrating: HardwareDevice.ActuatorSettings.InterlockedActuator <- HardwareDevice.InterlockedActuator');
            device.HardwareDevice.ActuatorSettings.InterlockedActuator = device.HardwareDevice.InterlockedActuator;
        }
        delete device.HardwareDevice.InterlockedActuator;
    }

    if (typeof device.HardwareDevice.ActuatorSettings.MinimumFlowRatePercentLeft === 'undefined') {
        logger.debug('[config.migration.actuator] Setting HardwareDevice.ActuatorSettings.MinimumFlowRatePercentLeft to default 0');
        device.HardwareDevice.ActuatorSettings.MinimumFlowRatePercentLeft = 0;
    }

    if (typeof device.HardwareDevice.ActuatorSettings.MinimumFlowRatePercentRight === 'undefined') {
        logger.debug('[config.migration.actuator] Setting HardwareDevice.ActuatorSettings.MinimumFlowRatePercentRight to default 0');
        device.HardwareDevice.ActuatorSettings.MinimumFlowRatePercentRight = 0;
    }

    if (typeof device.HardwareDevice.ActuatorSettings.WaterInletDirection === 'undefined') {
        logger.debug('[config.migration.actuator] Setting HardwareDevice.ActuatorSettings.WaterInletDirection to default: middle');
        device.HardwareDevice.ActuatorSettings.WaterInletDirection = "middle";
    }

}
